import { render, staticRenderFns } from "./InvitationSubmit.vue?vue&type=template&id=10a5e8da&scoped=true&"
import script from "./InvitationSubmit.vue?vue&type=script&lang=js&"
export * from "./InvitationSubmit.vue?vue&type=script&lang=js&"
import style0 from "./InvitationSubmit.vue?vue&type=style&index=0&id=10a5e8da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a5e8da",
  null
  
)

export default component.exports